import type { CSSProperties } from 'react';

export const TEXT_SHARP_STYLES: CSSProperties = {
  filter: 'none',
  WebkitFilter: 'none',
  textRendering: 'optimizeLegibility',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
};

export const MOBILE_OVERLAY_GRADIENT = 'linear-gradient(to top, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.5), transparent)';

export const DESKTOP_OVERLAY_GRADIENT = 'linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3), transparent)';
